/* ==========================================================================
   MDB — Estimation de livraison
   Calcule la fourchette de réception en JOURS OUVRÉS à partir de la date du
   jour, côté client.

   Pourquoi en JS et pas en Liquid : les pages produit sont mises en cache par
   le CDN Shopify. Une date calculée en Liquid resterait figée sur la date de
   rendu pendant des heures et afficherait une estimation fausse. Le calcul
   client garantit une date juste à chaque affichage.

   Les délais ne sont PAS codés ici : chaque bandeau porte ses propres bornes
   en data-mdb-eta-min / data-mdb-eta-max, alimentées par le bloc
   « Estimation de livraison » de l'éditeur de thème.

   Le décompte démarre au jour ouvré suivant la commande (pas d'heure limite).
   ========================================================================== */

(function () {
  'use strict';

  // Un seul init, même si le snippet est rendu plusieurs fois (flux + sticky).
  if (window.__mdbEtaInit) return;
  window.__mdbEtaInit = true;

  /* Jours fériés français. À prolonger au-delà de 2027 le moment venu :
     sans mise à jour, l'estimation reste correcte mais légèrement optimiste
     (un férié non listé n'est pas déduit). */
  var HOLIDAYS = [
    // 2026
    '2026-01-01', // Jour de l'an
    '2026-04-06', // Lundi de Pâques
    '2026-05-01', // Fête du travail
    '2026-05-08', // Victoire 1945
    '2026-05-14', // Ascension
    '2026-05-25', // Lundi de Pentecôte
    '2026-07-14', // Fête nationale
    '2026-08-15', // Assomption
    '2026-11-01', // Toussaint
    '2026-11-11', // Armistice
    '2026-12-25', // Noël
    // 2027
    '2027-01-01',
    '2027-03-29', // Lundi de Pâques
    '2027-05-01',
    '2027-05-06', // Ascension
    '2027-05-08',
    '2027-05-17', // Lundi de Pentecôte
    '2027-07-14',
    '2027-08-15',
    '2027-11-01',
    '2027-11-11',
    '2027-12-25'
  ];

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function isoDate(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function isBusinessDay(d) {
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    return HOLIDAYS.indexOf(isoDate(d)) === -1;
  }

  /* Avance de n jours ouvrés à partir de `start`, sans jamais compter le jour
     de départ : une commande passée un mardi commence à courir le mercredi. */
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    var guard = 0;
    // Garde-fou : un réglage aberrant dans l'éditeur ne doit pas boucler.
    while (added < n && guard < 2000) {
      d.setDate(d.getDate() + 1);
      guard += 1;
      if (isBusinessDay(d)) added += 1;
    }
    return d;
  }

  var hasIntl = typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function';

  var fmtFull = hasIntl
    ? new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' })
    : null;
  var fmtNoMonth = hasIntl
    ? new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric' })
    : null;

  function format(d, withMonth) {
    if (!hasIntl) return d.getDate() + '/' + pad(d.getMonth() + 1);
    var f = withMonth ? fmtFull : fmtNoMonth;
    // Intl produit « mar. 11 août » — on retire la virgule que certains
    // navigateurs insèrent après le jour de la semaine.
    return f.format(d).replace(',', '');
  }

  function buildRange(minDays, maxDays) {
    var today = new Date();
    var min = addBusinessDays(today, minDays);
    var max = addBusinessDays(today, maxDays);

    // Une seule date si les deux bornes sont identiques.
    if (min.getTime() === max.getTime()) {
      return 'le ' + format(max, true);
    }

    // Même mois ET même année → on ne répète pas le mois sur la borne basse.
    var sameMonth =
      min.getMonth() === max.getMonth() && min.getFullYear() === max.getFullYear();

    return 'entre le ' + format(min, !sameMonth) + ' et le ' + format(max, true);
  }

  function render() {
    var roots = document.querySelectorAll('[data-mdb-eta]');

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var target = root.querySelector('[data-mdb-eta-range]');
      if (!target) continue;

      var minDays = parseInt(root.getAttribute('data-mdb-eta-min'), 10);
      var maxDays = parseInt(root.getAttribute('data-mdb-eta-max'), 10);
      if (isNaN(minDays) || isNaN(maxDays)) continue;

      // Un min supérieur au max (saisie inversée dans l'éditeur) est corrigé
      // plutôt que d'afficher une fourchette à l'envers.
      if (minDays > maxDays) {
        var swap = minDays;
        minDays = maxDays;
        maxDays = swap;
      }

      target.textContent = buildRange(minDays, maxDays);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // La barre sticky et les swatches réinjectent parfois du markup après coup :
  // on repasse une fois au chargement complet pour couvrir ces cas.
  window.addEventListener('load', render);
})();
